/* eslint-disable no-unsafe-optional-chaining */
import {
  GKButton,
  GKModal,
  GKSearchSelect,
  GKTextField,
  Grid2,
  PopConfirm,
  Show,
  Typography,
} from "components";
import { useMutation } from "hooks/useQueries";
import { useState } from "react";
import { useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import CustomTable from "./CustomTable";

interface Props {
  portfolioGroup: any;
}

const EditPortfolioGroupDetails = (props: Props & GKModalProps) => {
  const { open, setOpen, portfolioGroup } = props;

  const portfolios = useAppSelector((state) => state?.app?.portfolios);

  const [portfolioGroupName, setPortfolioGroupName] = useState(
    portfolioGroup?.name,
  );

  const [selectedPortfolio, setSelectedPortfolio] = useState([]);

  const [isDeleteModalOpen, setIsDeleteModalOpen] =
    useState<HTMLElement | null>(null);

  const [dataToSubmit, setDataToSubmit] = useState(
    portfolioGroup?.portfolioList,
  );

  const { mutate: handleDeleteGroup } = useMutation({
    mutationFn: (groupId: any) =>
      axiosInstance.delete(`/portfolio-groups/${groupId}/`),
    onSuccess: () => {
      setOpen(false);
      refetchQuery(QueryKeys.PORTFOLIO_GROUP_LIST);
    },
  });

  const { mutate: handleUpdateGroup, isLoading } = useMutation({
    mutationFn: ({ dataToBeSent, groupId, groupName }: any) =>
      axiosInstance.patch(`/portfolio-groups/${groupId}/`, {
        id: groupId,
        name: groupName,
        portfolios: dataToBeSent,
      }),
    onSuccess: () => {
      setOpen(false);
      refetchQuery(QueryKeys.PORTFOLIO_GROUP_LIST);
      refetchQuery("GET_PORTFOLIOGROUP_BY_ID");
    },
  });

  const handlePortfolioGroupSave = async () => {
    const dataToBeSent = [...new Set(dataToSubmit)]?.map(
      (item: any) => item?.id,
    );
    handleUpdateGroup({
      groupId: portfolioGroup?.id,
      groupName: portfolioGroupName,
      dataToBeSent: dataToBeSent,
    });
  };

  const selectData = portfolios.filter(
    (data: any): any =>
      !selectedPortfolio
        ?.map((dataItem) => dataItem?.portfolioId)
        ?.includes(data?.portfolioId),
  );

  return (
    <GKModal
      modalTitle="Edit Portfolio Group Details"
      open={open}
      setOpen={setOpen}
      footer={
        <GKButton
          loading={isLoading}
          variant="contained"
          size="medium"
          disabled={isLoading}
          onClick={() => handlePortfolioGroupSave()}
        >
          Save
        </GKButton>
      }
      titleComponent={
        <GKButton
          variant="outlined"
          color="error"
          size="medium"
          onClick={(e) => setIsDeleteModalOpen(e.currentTarget)}
        >
          Delete Portfolio Group
        </GKButton>
      }
    >
      <Grid2 container spacing={1}>
        <Grid2 size={12}>
          <GKTextField
            value={portfolioGroupName}
            inputLabel={"Portfolio Group Name"}
            onChange={(event) => {
              setPortfolioGroupName(event.target.value);
            }}
          />
        </Grid2>
        <Grid2 size={12}>
          <GKSearchSelect
            multiple
            disableClearable
            getOptionLabel={(option) => option?.name || option}
            renderOption={(props, option) => {
              return (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <Typography fontWeight={600}>{option.clientName}</Typography>
                  <Typography>{option.name}</Typography>
                </li>
              );
            }}
            inputLabel="Select Portfolios to add"
            options={selectData || []}
            value={[]}
            onChange={(value, val) => {
              const dataItems = val?.map((item: any) => {
                return {
                  name: item.name,
                  value: item.value,
                  portfolioId: item.portfolioId,
                  id: item.value,
                  phone: "",
                  clientName: "",
                };
              });
              setDataToSubmit([...dataToSubmit, ...dataItems]);
              setSelectedPortfolio([...selectedPortfolio, ...val]?.flat());
            }}
          />
        </Grid2>
        <Grid2 size={12}>
          <CustomTable
            dataToSubmit={dataToSubmit}
            setDataToSubmit={setDataToSubmit}
            setSelectedPortfolio={setSelectedPortfolio}
          />
        </Grid2>

        <Show.When isTrue={Boolean(isDeleteModalOpen)}>
          <PopConfirm
            anchorEl={isDeleteModalOpen}
            open={Boolean(isDeleteModalOpen)}
            setOpen={setIsDeleteModalOpen}
            onSuccess={() => handleDeleteGroup(portfolioGroup?.id)}
          />
        </Show.When>
      </Grid2>
    </GKModal>
  );
};

export default EditPortfolioGroupDetails;
